import { render, staticRenderFns } from "./UploadArquivos.vue?vue&type=template&id=b7077e02&"
import script from "./UploadArquivos.vue?vue&type=script&lang=js&"
export * from "./UploadArquivos.vue?vue&type=script&lang=js&"
import style0 from "./UploadArquivos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports